const Response = require("./Response");

const Axios = require("axios");

const axiosRetry = require("axios-retry");

class HttpSender {
  constructor() {
    let timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
    let retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    let proxyConfig = arguments.length > 2 ? arguments[2] : undefined;
    let debug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    axiosRetry(Axios, {
      retries: retries
    });
    this.timeout = timeout;
    this.proxyConfig = proxyConfig;
    if (debug) this.enableDebug();
  }

  buildRequestConfig(_ref) {
    let payload = _ref.payload,
        parameters = _ref.parameters,
        headers = _ref.headers,
        baseUrl = _ref.baseUrl;
    let config = {
      method: "GET",
      timeout: this.timeout,
      params: parameters,
      headers: headers,
      baseURL: baseUrl,
      validateStatus: function (status) {
        return status < 500;
      }
    };

    if (payload) {
      config.method = "POST";
      config.data = payload;
    }

    if (this.proxyConfig) config.proxy = this.proxyConfig;
    return config;
  }

  buildSmartyResponse(response, error) {
    if (response) return new Response(response.status, response.data);
    return new Response(undefined, undefined, error);
  }

  send(request) {
    return new Promise((resolve, reject) => {
      let requestConfig = this.buildRequestConfig(request);
      Axios(requestConfig).then(response => {
        let smartyResponse = this.buildSmartyResponse(response);
        if (smartyResponse.statusCode >= 400) reject(smartyResponse);
        resolve(smartyResponse);
      }).catch(error => reject(this.buildSmartyResponse(undefined, error)));
    });
  }

  enableDebug() {
    Axios.interceptors.request.use(request => {
      console.log('Request:\r\n', request);
      console.log('\r\n*******************************************\r\n');
      return request;
    });
    Axios.interceptors.response.use(response => {
      console.log('Response:\r\n');
      console.log('Status:', response.status, response.statusText);
      console.log('Headers:', response.headers);
      console.log('Data:', response.data);
      return response;
    });
  }

}

module.exports = HttpSender;